import { useState } from 'react';
import { FaArrowRightLong } from 'react-icons/fa6';
import { IoClose } from 'react-icons/io5';
import { useTheme } from 'styled-components';

import { Button, Typography } from '../../../designComponents';
import { AdvertiseStyled } from './style';

const Advertise = () => {
  const theme = useTheme();
  const [ishide, setIshide] = useState(false);
  const handleHide = () => {
    setIshide(true);
  };
  return (
    <AdvertiseStyled $ishide={ishide}>
      <div className="main-text">
        <Typography className="small-screen-text">
          Introducing Escape Plan, ...
        </Typography>
        <Typography className="large-screen-text">
          Introducing Escape Plan, your key to potentially saving up to €6
          million!
        </Typography>
        <Button
          variant="nostyle"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <Typography
            style={{
              textDecoration: 'underline',
              color: theme.colors.primary,
            }}
          >
            Learn More
          </Typography>
          <FaArrowRightLong color={theme.colors.primary} size={10} />
        </Button>
      </div>
      <IoClose size={20} onClick={handleHide} cursor="pointer" />
    </AdvertiseStyled>
  );
};

export default Advertise;
